module.exports = __webpack_public_path__ + "img/46.8f20ddfa.jpg";